/* do not change this file, it is auto generated by storybook. */
import { start, updateView, View } from '@storybook/react-native';



const normalizedStories = [
  {
    titlePrefix: "",
    directory: "./app/__stories_7__",
    files: "**/*.stories.?(js|jsx|ts|tsx)",
    importPathMatcher: /^\.(?:(?:^|\/|(?:(?:(?!(?:^|\/)\.).)*?)\/)(?!\.)(?=.)[^/]*?\.stories\.(?:js|jsx|ts|tsx)?)$/,
    // @ts-ignore
    req: require.context(
      '../app/__stories_7__',
      true,
      /^\.(?:(?:^|\/|(?:(?:(?!(?:^|\/)\.).)*?)\/)(?!\.)(?=.)[^/]*?\.stories\.(?:js|jsx|ts|tsx)?)$/
    ),
  }
];


declare global {
  var view: View;
  var STORIES: typeof normalizedStories;
}


const annotations = [
  require('./preview'),
  require("@storybook/react-native/preview")
];

global.STORIES = normalizedStories;

// @ts-ignore
module?.hot?.accept?.();



if (!global.view) {
  global.view = start({
    annotations,
    storyEntries: normalizedStories,

  });
} else {
  updateView(global.view, annotations, normalizedStories);
}

export const view: View = global.view;
